export type ImageSize = { width: number; height: number };

type AssetDims = { naturalWidth: number; naturalHeight: number };

export function scaleToWidth(dims: AssetDims, width: number): ImageSize {
  return { width, height: Math.round((dims.naturalHeight / dims.naturalWidth) * width) };
}

export function scaleToHeight(dims: AssetDims, height: number): ImageSize {
  return { width: Math.round((dims.naturalWidth / dims.naturalHeight) * height), height };
}
